import service from '@/store/services/workshop/parking_line-service';

const state = {
  list: {},
  parking_line: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, parking_line) => {
    state.parking_line = parking_line;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  
  quota ({commit, dispatch}, params) {
    return service.quota(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((parking_line) => { commit('SET_RESOURCE', parking_line); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((parking_line) => { commit('SET_RESOURCE', parking_line); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((parking_line) => { commit('SET_RESOURCE', parking_line); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  parking_line: state => state.parking_line,
  page: state => state.meta.page,
};
 
const parking_line = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default parking_line;
